"use client";

import { useEffect } from "react";

import { ErrorView, primaryBtnClass, secondaryBtnClass } from "@/components/error/error-view";
import "./globals.css";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <body className="bg-teal-01 text-grey-09 antialiased">
        <ErrorView
          eyebrow="Something went wrong"
          title="This page didn't load properly"
          message="Sorry — something went wrong on our end. It's usually temporary, so please try again. If it keeps happening, we're here to help."
        >
          <button type="button" onClick={reset} className={primaryBtnClass}>
            Try again
          </button>
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- full reload recovers from the broken tree */}
          <a href="/" className={secondaryBtnClass}>
            Back to home
          </a>
        </ErrorView>
      </body>
    </html>
  );
}
